import React from "react";
import { Redirect } from "react-router-dom";

//pages

//login
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import NoAccessPermission from "../pages/Authentication/NoAccessPermission";
import User from "../pages/Authentication/User";
import Role from "../pages/Authentication/Role";
import Action from "../pages/Authentication/Action";
import DepartmentManagement from "../pages/DepartmentManagement";
import GroupManagement from "../pages/GroupManagement";
import CompanyManagement from "../pages/CompanyManagement";
import Shift from "../pages/Shift";
import AttendanceId from "../pages/Attendance";
import ApplicationManagement from "../pages/ApplicationManagement";
import History from "../pages/History";
import duplicateIP from "../pages/History/duplicateIP";
import duplicateFP from "../pages/History/duplicateFP";
import duplicateIpAndFp from "../pages/History/duplocateFpAnhIp.js";
import duplicateIPOld from "../pages/History/duplicateIPOld";
import duplicateFPOld from "../pages/History/duplicateFPOld";
import Profile from "../store/auth/profile/profile";
import ActionHistory from "../pages/ActionHistory";
import DashboardEmployee from "../pages/Dashboard/DashboardEmployee";
import DashboardApplication from "../pages/Dashboard/DashboardApplication";
import DashboardHistory from "../pages/Dashboard/DashboardHistory";
import duplicateIPCollab from "../pages/History/duplicateIPCollab";
import duplicateFPCollab from "../pages/History/duplicateFPCollab";
import bot from "../pages/bot";
import message from "../pages/message";
import rules from "../pages/Rules";
import Notify from "../pages/Notify";

const pathRoleUser =
  sessionStorage.getItem("pathRoleUser") !== "undefined"
    ? JSON.parse(sessionStorage.getItem("pathRoleUser"))
    : "";

const authProtectedRoutes = [
  { path: "/dashboard-employee", component: DashboardEmployee },
  { path: "/dashboard-application", component: DashboardApplication },
  { path: "/dashboard-history", component: DashboardHistory },
  { path: "/employee-manager", component: User },
  { path: "/shift", component: Shift },
  { path: "/attendance/:id", component: AttendanceId },
  { path: "/role", component: Role },
  { path: "/action", component: Action },
  { path: "/department-management", component: DepartmentManagement },
  { path: "/group-management", component: GroupManagement },
  { path: "/company-management", component: CompanyManagement },
  { path: "/application-management", component: ApplicationManagement },
  { path: "/history", component: History },
  { path: "/duplicate-ip", component: duplicateIP },
  { path: "/duplicate-fp", component: duplicateFP },
  { path: "/duplicate-ip-fp", component: duplicateIpAndFp },
  { path: "/duplicate-ip-old", component: duplicateIPOld },
  { path: "/duplicate-fp-old", component: duplicateFPOld },
  { path: "/profile", component: Profile },
  { path: "/action-history", component: ActionHistory },
  { path: "/duplicate-ip-collab", component: duplicateIPCollab },
  { path: "/duplicate-fp-collab", component: duplicateFPCollab },
  { path: "/bot", component: bot },
  { path: "/message", component: message },
  { path: "/rules", component: rules },
  { path: "/notify", component: Notify },
  {
    path: "/*",
    exact: true,
    component: () => (
      <Redirect to={`/${pathRoleUser ? "dashboard-employee" : ""}`} />
    ),
  },
];

const publicRoutes = [
  // Authentication Page
  { path: "/login", component: Login },
  { path: "/logout", component: Logout },
  { path: "/no-access-permission", component: NoAccessPermission },
];

export { authProtectedRoutes, publicRoutes };
